module.exports = __webpack_public_path__ + "img/175.side_courses.10d9b9c6.svg";